import * as S from './giftcard-details.styles';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DetailView from './detail-view/detail-view.component';
import GiftcardBalance from './giftcard-balance/giftcard-balance.component';

const GiftCardDetails = ({ giftcard }) => {
  const { t } = useTranslation();
  const { securityCode, cardAccountBalance, cardIdentifier } = giftcard;

  if (securityCode)
    return (
      <>
        <Box textAlign="center">
          <GiftcardBalance cardAccountBalance={cardAccountBalance} />
        </Box>
        <Box
          mb={2}
          display="flex"
          justifyContent="space-between"
          flexDirection="row"
        >
          <DetailView
            label={t('eGiftCard.view.cardNumber')}
            detail={cardIdentifier}
            testId="GiftcardView.CardIdentifier"
          />
          <S.VerticalDivider orientation="vertical" flexItem />
          <DetailView
            label={t('eGiftCard.view.securityCode')}
            detail={securityCode}
            testId="GiftcardView.SecurityCode"
            noBreak
          />
        </Box>
      </>
    );

  return (
    <Box
      mb={2}
      display="flex"
      justifyContent="space-between"
      flexDirection="row"
    >
      <GiftcardBalance cardAccountBalance={cardAccountBalance} />
      <S.VerticalDivider orientation="vertical" flexItem />
      <DetailView
        label={t('eGiftCard.view.cardNumber')}
        detail={cardIdentifier}
        testId="GiftcardView.CardIdentifier"
      />
    </Box>
  );
};

export default GiftCardDetails;
